import React, { useState } from "react";
import { Message } from "../lib/messagesLib";
import { createRule, CreateRuleDTO } from "../lib/rulesLib";
interface MessageRowDetailProps {
  message: Message;
}

const MessageRowDetail: React.FC<MessageRowDetailProps> = ({ message }) => {
  const [rule, setRule] = useState<CreateRuleDTO>({
    messageId: message.id,
    scopeTargetType: "global",
    scopeTargetId: null,
    ruleAction: "filter",
    extraSourceOption: null,
    category: "",
    selectedHeaders: {},
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setRule((prevState) => ({
      ...prevState,
      [name]: value === "none" ? null : value,
    }));
  };

  const handleHeaderToggle = (headerName: string) => {
    setRule((prevState) => ({
      ...prevState,
      selectedHeaders: {
        ...prevState.selectedHeaders,
        [headerName]: !prevState.selectedHeaders?.[headerName],
      },
    }));
  };

  const handleSubmit = () => {
    console.log("Creating rule:", rule);
    createRule(rule);
  };

  return (
    <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded shadow-md truncate">
      <div className="mt-4">
        <button
          onClick={handleSubmit}
          className="px-4 py-2 bg-blue-500 hover:bg-blue-700 text-white rounded"
        >
          Create Rule
        </button>
      </div>
      <div className="flex">
        {/*new rule options and toggles*/}
        <div className="w-1/2">
          <div className="mb-4">
            <div className="font-semibold mb-2 dark:text-gray-200">Action</div>
            <div className="dark:text-gray-300">
              <label className="mr-2">
                <input
                  type="radio"
                  name="ruleAction"
                  value="allow"
                  checked={rule.ruleAction === "allow"}
                  onChange={handleInputChange}
                />
                Allow
              </label>
              <label className="mr-2">
                <input
                  type="radio"
                  name="ruleAction"
                  value="challenge"
                  checked={rule.ruleAction === "challenge"}
                  onChange={handleInputChange}
                />
                Challenge
              </label>
              <label>
                <input
                  type="radio"
                  name="ruleAction"
                  value="filter"
                  checked={rule.ruleAction === "filter"}
                  onChange={handleInputChange}
                />
                Filter
              </label>
            </div>
          </div>
          <div className="mb-4">
            <div className="font-semibold mb-2 dark:text-gray-200">Target</div>
            <div className="dark:text-gray-300">
              <label className="mr-2">
                <input
                  type="radio"
                  name="extraSourceOption"
                  value="none"
                  checked={rule.extraSourceOption === null}
                  onChange={handleInputChange}
                />
                <i>none</i>
              </label>
              <label className="mr-2">
                <input
                  type="radio"
                  name="extraSourceOption"
                  value="sender"
                  checked={rule.extraSourceOption === "sender"}
                  onChange={handleInputChange}
                />
                Sender
              </label>
              <label className="mr-2">
                <input
                  type="radio"
                  name="extraSourceOption"
                  value="domain"
                  checked={rule.extraSourceOption === "domain"}
                  onChange={handleInputChange}
                />
                Domain
              </label>
              <label>
                <input
                  type="radio"
                  name="extraSourceOption"
                  value="subject"
                  checked={rule.extraSourceOption === "subject"}
                  onChange={handleInputChange}
                />
                Subject
              </label>
            </div>
          </div>
          <div className="mb-4">
            <div className="font-semibold mb-2 dark:text-gray-200">Scope</div>
            <div className="dark:text-gray-300">
              <label className="mr-2">
                <input
                  type="radio"
                  name="scopeTargetType"
                  value="global"
                  checked={rule.scopeTargetType === "global"}
                  onChange={handleInputChange}
                />
                Global
              </label>
              <label>
                <input
                  type="radio"
                  name="scopeTargetType"
                  value="user"
                  checked={rule.scopeTargetType === "user"}
                  onChange={handleInputChange}
                />
                User
              </label>
              <label>
                <input
                  type="radio"
                  name="scopeTargetType"
                  value="inbox"
                  checked={rule.scopeTargetType === "inbox"}
                  onChange={handleInputChange}
                />
                Inbox
              </label>
            </div>
          </div>
          <div className="mb-4">
            <div className="font-semibold mb-2 dark:text-gray-200">
              Category
            </div>
            <select
              name="category"
              value={rule.category}
              onChange={handleInputChange}
              className="p-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
            >
              <option>none</option>
              <option value="marketing">Marketing</option>
              <option value="shopping">Shopping</option>
              <option value="newsletter">Newsletter</option>
              <option value="sales">Sales</option>
            </select>
          </div>
        </div>
        {/*header selectors for new rule*/}
        <div className="w-96 pl-4 truncate">
          <div className="font-semibold mb-2 dark:text-gray-200">Headers</div>
          {message?.headers?.map(
            (header: { name: string; value: string }, index: number) => (
              <div
                key={index}
                className="flex justify-between items-center mb-1 dark:text-gray-300"
              >
                <input
                  type="checkbox"
                  checked={!!rule?.selectedHeaders?.[header.name]}
                  onChange={() => handleHeaderToggle(header.name)}
                  className="dark:bg-gray-700 dark:border-gray-600"
                />
                <span className="ml-2 truncate w-1/2">{header.name}</span>
                <span className="truncate w-1/2" title={header.value}>
                  {header.value}
                </span>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageRowDetail;
